import React from 'react';
import { OverviewComponentType, ProductOverviewRegistry } from '../../../types';
import ApplicationPerformanceScorecard from '@containers/ApplicationPerformanceRedesigned/ApplicationPerformanceStandardMetrics/ApplicationPerformanceScorecard';
import SummaryMetricsPepIRis from '@containers/UserBehaviorEngagement/PepIRis/SummaryMetricsPepIRis';
import { helperFunctions } from '@utils/helperFunctions';

/**
 * Application Performance Scorecard Component
 * Only renders in lower environments (dev, QA, pre-prod)
 */
const ApplicationPerformanceScorecardComponent: OverviewComponentType = () => {
  const { isDevOrQaOrPreProdEnv } = helperFunctions();

  // Only show in lower environments (dev, QA, pre-prod)
  if (!isDevOrQaOrPreProdEnv()) {
    return null;
  }

  return (
    <ApplicationPerformanceScorecard
      title="App Performance"
      showInfoIcon={true}
    />
  );
};

/**
 * User Adoption Summary Metrics Component
 * Always renders regardless of environment
 */
const UserAdoptionMetricsComponent: OverviewComponentType = () => (
  <SummaryMetricsPepIRis title="User Adoption" />
);

// Define the scorecards array with descriptive component names
const scorecards: OverviewComponentType[] = [
  ApplicationPerformanceScorecardComponent,
  UserAdoptionMetricsComponent,
];

// No custom overview component for this product
const customOverview: OverviewComponentType | null = null;

/**
 * PepIRiS Product Overview Registry
 * Contains scorecards and custom overview configuration
 */
const PepIRiSRegistry: ProductOverviewRegistry = {
  scorecards,
  customOverview,
};

export default PepIRiSRegistry;
